/*
 * @Author: your name
 * @Date: 2021-08-17 16:50:08
 * @LastEditTime: 2021-10-28 14:52:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/study/mathematics/index.tsx
 */
import React, { useState } from 'react';
import { jsPDF } from "jspdf";
import { Button, Form, Input, Radio, InputNumber, Checkbox, message } from "antd";
import './index.css';
import { courses, question, submit } from './api';
import { exportPDF } from '../../../common/pdf';
import { stat } from 'fs';

const doc = new jsPDF();
doc.text("Hello world!", 10, 10);

export function Example() {
    const [coursesVal, setCourses] = useState('');
    const [status, setStatus] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [list, setList]: any = useState([]);
    const [topic, setTopic] = useState([]);
    const onFinish = (values: any) => {
        setLoadingStatus(true)
        if (topic.length === 0) return message.error('选择题库类型');
        if (submit(values)) {
            setList(submit(values))
            setTimeout(() => {
                setStatus(true);
                setLoadingStatus(false)
            }, 3000);
        } else {
            message.error('题库生成错误，请与管理员联系');
        }
    };

    return (
        <div className='center mathBrack' >
            <Form name="basic"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 8 }}
                onFinish={onFinish}
            >
                <Form.Item
                    label="年级单选"
                    name="username"
                    rules={[{ required: true, message: '请选择年级!' }]}
                >
                    <Radio.Group options={courses}
                        onChange={(value) => {
                            setCourses(value.target.value);
                            setTopic([]);
                        }} />
                </Form.Item>
                {coursesVal === '' ? null :
                    <Form.Item
                        label="多选题库"
                        name="topic"
                        rules={[{ required: true, message: '请选择打印题库类型!' }]}
                    >
                        <Checkbox.Group className='Checkbox_Group'
                            options={question[coursesVal]}
                            onChange={(value: any) => {
                                setTopic(value)
                            }} />
                    </Form.Item>
                }

                <Form.Item label="总题数" required>
                    <Input.Group compact>
                        <Form.Item
                            name={['totalNum']}
                            rules={[{ required: true, message: '请输入总题数!最大400' }]}
                        >
                            <InputNumber min={1} max={400} />
                        </Form.Item>
                        <Form.Item
                        >
                            <span style={{ color: '#989595d9', fontSize: 12, marginLeft: 20 }}>温馨提示：63条/页最佳</span>
                        </Form.Item>
                    </Input.Group>
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit" loading={loadingStatus}>
                        生成PDF
                    </Button>
                </Form.Item>
            </Form>
            <div id='crfContent'>
                {list.map((item: string, index: number) => {
                    return <p className='pdfRow' key={index}>{item}</p>
                })}
            </div>
            {
                status ? <>{exportPDF('11244', 'crfContent')}</> : null
            }
        </div >
    );
}


// export class Mathematics extends React.Component<{}, {}> {
//     render() {
//         return <div>
//             
//             {Example()}
//         </div>
//     }
// }